import { IS_CANADA_MARKET } from "./EmpUtil";

export const AGREEMENT_ACCEPTED_STATUS = "ACCEPTED";

export const isCanadianPreorderMarket = (user) =>
  IS_CANADA_MARKET(user?.market) && ["F", "L"].includes(user?.brand);

export const hasCustomerHandlingRole = (user) => {
  const roles = Array.isArray(user?.roles)
    ? user.roles
    : Object.values(user?.roles || {});
  const normalizedRoles = roles.map((role) => String(role).toUpperCase());

  return normalizedRoles.includes("EMP_ECOMM_CUSTOMERHANDLING");
};

export const isCanadianPreorderUser = (
  user,
  agreementStatus = user?.preorderAgreementStatus
) =>
  ["na_dealer", "ecomm_onboarding"].includes(user?.userType) &&
  isCanadianPreorderMarket(user) &&
  hasCustomerHandlingRole(user) &&
  agreementStatus === AGREEMENT_ACCEPTED_STATUS;

export const usesDealerExperienceRoutes = (user) =>
  user?.userType === "na_dealer" || isCanadianPreorderUser(user);
